import {
	container,
	title,
	cardTitle,
	description,
	mlAuto,
	mrAuto,
	blackColor,
	whiteColor,
	grayColor,
	hexToRgb,
} from "assets/jss/material-kit-pro-react.js";

import modalStyle from "assets/jss/material-kit-pro-react/modalStyle.js";
import tooltipsStyle from "assets/jss/material-kit-pro-react/tooltipsStyle.js";
import popoverStyles from "assets/jss/material-kit-pro-react/popoverStyles.js";
import customCheckboxRadioSwitch from "assets/jss/material-kit-pro-react/customCheckboxRadioSwitchStyle.js";
import { boxShadow } from "assets/jss/material-kit-pro-react";

const customerDetailsStyles = (theme) => ({
	container,
	description,
	cardTitle,
	mlAuto,
	mrAuto,
	...tooltipsStyle,
	...popoverStyles,
	...modalStyle(theme),
	...customCheckboxRadioSwitch,
	section: {
		padding: "70px 0 0",
	},
	title: {
		...title,
		marginTop: "30px",
		minHeight: "32px",
		textDecoration: "none",
	},
	titleProducts: {
		marginTop: "10px",
		marginBottom: "10px",
		fontSize: "20px",
		// fontWeight: "bold",
		fontFamily: "Rubik-Medium",
	},
	icon: {
		width: "24px",
		height: "24px",
		color: grayColor[13],
	},
	containerBox: {
		margin: "0 auto",
		maxWidth: "1400px",
	},
	py2: {
		paddingTop: "5px",
		paddingBottom: "5px",
	},
	qrBtn: {
		color: "#272727FF",
		borderColor: "#ffffff",
	},
	customerTitle: {
		fontSize: "18px",
		marginLeft: "5px",
		fontFamily: "Rubik-Medium",
		marginLeft: "10px",
	},
	companyTitle: {
		fontSize: "18px",
		marginLeft: "20px",
		paddingTop: "10px",
		fontFamily: "Rubik-Medium",
	},
	searchInput: {
		fontSize: "14px",
		fontWeight: "normal",
		// color: "#031825FF",
		fontFamily: "Rubik-Regular",
	},
	companyStatus: {
		fontSize: "18px",
		color: "#999999FF",
		fontFamily: "Rubik-Medium",
	},
	width30: {
		maxWidth: "300px",
	},
	py5: {
		paddingTop: "10px",
		paddingBottom: "10px",
	},
	px5: {
		paddingLeft: "10px",
		paddingRight: "10px",
	},
	mx5: {
		marginLeft: "10px",
		marginRight: "10px",
	},
	mxr10: {
		marginRight: "20px",
	},
	mxl10: {
		marginLeft: "20px",
	},
	my: {
		marginTop: "5px",
		marginBottom: "5px",
	},
	mx: {
		marginLeft: "5px",
		marginRight: "5px",
	},
	my5: {
		marginTop: "10px",
		marginBottom: "10px",
	},
	mT: {
		marginTop: "10px",
	},
	mT20: {
		marginTop: "20px",
	},
	mT30: {
		marginTop: "20px",
	},
	mB: {
		marginBottom: "10px",
	},
	mL: {
		marginLeft: "10px",
	},
	userWelcomeSection: {
		marginLeft: "50px",
	},
	mR: {
		marginRight: "10px",
	},
	sortIcon: {
		color: "#072A40",
		marginLeft: "5px",
		marginRight: "5px",
		marginTop: "5px",
		cursor: "pointer",
		"&:hover": {
			color: "#072A40",
		},
	},
	learnMore: {
		fontSize: "12px",
		color: "#077DC7FF",
		fontFamily: "Rubik-regular",
		cursor: "pointer",
		marginTop: "5px",
		marginBottom: "5px",
	},
	learnMoreIcon: {
		color: "#077DC7FF",
		fontSize: "12px",
		paddingTop: "2px",
		marginLeft: "5px",
		marginRight: "5px",
	},
	my10: {
		marginTop: "20px",
		marginBottom: "20px",
	},
	rightSideBorder: {
		borderRight: "1px solid #e0e0e0",
		minHeight: "100vh",
		maxHeight: "100vh",
		overflowY: "scroll",
		overflowX: "hidden",
	},
	width100: {
		width: "100%",
	},
	selectedCustomer: {
		textAlign: "left",
	},
	leftAlign: {
		textAlign: "left",
	},
	rightAlign: {
		textAlign: "right",
	},
	customerListHeader: {
		position: "relative",
	},
	customerListHeaderTitle: {
		width: "90%",
		textAlign: "left",
		fontFamily: "Rubik-medium",
		fontSize: "14px",
		fontWeight: "400",
	},
	positionToRight: {
		position: "absolute",
		right: "10px",
		top: "0",
	},
	btnGroup: {
		display: "flex",
	},
	paginationSection: {
		borderTop: "2px solid #e0e0e0",
		marginTop: "15px",
	},
	bottomBorder: {
		borderBottom: "1px solid #e0e0e0",
	},
	topBorder: {
		borderTop: "1px solid #e0e0e0",
	},
	productTiles: {
		cursor: "pointer",
		fontSize: "14px",
		fontWeight: "500",
		marginLeft: "15px",
		marginRight: "15px",
		marginTop: "5px",
		marginBottom: "5px",
		borderRadius: "2px",
		backgroundColor: "#ffffff",
		border: "0.5px solid #e0e0e0",
		padding: "5px",
		boxShadow: "0.5px 0.5px 0.5px #E3E3E3FF",
		transition: "all 0.1s ease",
		"&:hover": {
			backgroundColor: "#ECF8FAFF",
			boxShadow: "1px 0.5px 0.5px #DC2172FF",
		},
	},
	moveRight: {
		textAlign: "right",
	},
	cursorPointer: {
		cursor: "pointer",
	},
	linkOpen: {
		cursor: "pointer",
		color: "#0D34E2AD",
	},
	my20: {
		marginTop: "40px",
		marginBottom: "40px",
	},
	tableHeaderCell: {
		borderTop: "1px solid #e0e0e0 !important",
		borderBottom: "1px solid #e0e0e0",
		padding: "10px !important",
		paddingLeft: "5px !important",
		fontSize: "14px !important",
	},
	inputBox: {
		margin: "0 auto",
		maxWidth: "50px",
	},
	buttonIcon: {
		fontSize: "14px",
	},
	inputBx: {
		marginLeft: "10px",
		marginRight: "10px",
	},
	my30: {
		marginTop: "60px",
		marginBottom: "60px",
	},
	my20: {
		marginTop: "45px",
		marginBottom: "60px",
	},
	titleLabel: {
		fontSize: "15px",
		fontWeight: "bolder",
		marginTop: "0",
		marginBottom: "0",
		color: "inherit",
	},
	accountSection: {
		position: "relative",
		padding: "10px",
		marginBottom: "10px",
	},
	minHeight: {
		minHeight: "0vh",
	},
	alignRight: {
		float: "right",
	},
	alignDiv: {
		textAlign: "right",
		marginRight: "30px",
	},
	buttonPrimary: {
		marginTop: "5px",
		marginBottom: "5px",
		fontSize: "0.6875rem",
		borderRadius: "0.2rem",
		textTransform: "uppercase",
		lineHeight: "1.5",
		fontFamily: "Rubik-Medium",
		fontWeight: "400",
		padding: "0.40625rem 1.25rem",
		fontWeight: "500",
		verticalAlign: "middle",
		backgroundColor: "#ffffff",
		borderColor: "#072A40",
		color: "#072A40",
		border: "1px solid #072A40",
		transition: "all 0.1s ease",
		cursor: "pointer",
		marginRight: "10px",
		"&:hover": {
			backgroundColor: "#072A40",
			color: "#ffffff",
			border: "1px solid #072A40",
			transition: "all 0.4s ease",
			boxShadow:
				"0 1px 1px 0 #072A40, 0 2px 1px -2px #072A40, 0 1px 2px 0 #072A40",
		},
		"&:disabled": {
			backgroundColor: "#072A40",
			color: "#ffffff",
			border: "1px solid #072A40",
			opacity: "0.5",
		},
	},
	subscriptionUpgrade: {
		marginTop: "5px",
		marginBottom: "5px",
		fontSize: "0.6875rem",
		width: "165px",
		borderRadius: "0.2rem",
		textTransform: "uppercase",
		lineHeight: "1.5",
		textAlign: "left",
		fontFamily: "Rubik-Medium",
		fontWeight: "400",
		padding: "5px",
		fontWeight: "500",
		backgroundColor: "#ffffff",
		borderColor: "#072A40",
		color: "#072A40",
		border: "1px solid #072A40",
		transition: "all 0.1s ease",
		cursor: "pointer",
		"&:hover": {
			backgroundColor: "#072A40",
			color: "#ffffff",
			border: "1px solid #072A40",
			transition: "all 0.4s ease",
			boxShadow:
				"0 1px 1px 0 #072A40, 0 2px 1px -2px #072A40, 0 1px 2px 0 #072A40",
		},
	},
	headerPrimary: {
		marginTop: "5px",
		marginBottom: "5px",
		fontSize: "0.6875rem",
		borderRadius: "0.2rem",
		textTransform: "uppercase",
		lineHeight: "1.5",
		fontFamily: "Rubik-Medium",
		fontWeight: "400",
		padding: "0.40625rem 0.85rem",
		fontWeight: "500",
		verticalAlign: "middle",
		backgroundColor: "transparent",
		borderColor: "#E4E4E4FF",
		color: "#E4E4E4FF",
		border: "0.5px solid #ffffff",
		transition: "all 0.5s ease",
		cursor: "pointer",
		marginRight: "10px",
		"&:hover": {
			backgroundColor: "#E4E4E4FF",
			color: "#072A40",
			border: "0.5px solid #E4E4E4FF",
			opacity: "0.5",
			transition: "all 0.4s ease",
			boxShadow:
				"0 1px 1px 0 #072A40, 0 2px 1px -2px #072A40, 0 1px 2px 0 #072A40",
		},
		"&:disabled": {
			backgroundColor: "#072A40",
			color: "#E4E4E4FF",
			border: "1px solid #072A40",
			opacity: "0.5",
		},
	},
	buttonIcon: {
		fontSize: "18px",
	},
	justifyInBetween: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
	},
	width50: {
		maxWidth: "50px",
	},
	marginAuto: {
		margin: "auto",
		paddingBottom: "10px",
	},
	tilesTitle: {
		fontSize: "12px",
		transition: "0.3s ease all",
		lineHeight: "1.428571429",
		fontWeight: "400",
		fontFamily: "Rubik-Medium",
		paddingLeft: "0",
		color: "#072A40",
	},
	tilesDescription: {
		fontSize: "12px",
		transition: "0.3s ease all",
		lineHeight: "1.428571429",
		fontWeight: "200",
		fontFamily: "Rubik-Light",
		paddingLeft: "0",
		textAlign: "justify",
		marginTop: "5px",
		color: "#072A40",
	},
	labelAc: {
		fontSize: "14px",
		transition: "0.3s ease all",
		lineHeight: "1.428571429",
		fontWeight: "400",
		fontFamily: "Rubik-Medium",
		paddingLeft: "0",
		color: "#072A40",
	},
	cartLabel: {
		fontFamily: "Rubik-Medium",
		fontSize: "16px",
		transition: "0.3s ease all",
		lineHeight: "1.428571429",
		fontWeight: "500",
		paddingLeft: "0",
	},
	popularSection: {
		textAlign: "right",
		marginTop: "10px",
	},
	reportTitle: {
		display: "flex",
		fontSize: "20px",
		transition: "0.3s ease all",
		lineHeight: "1.428571429",
		fontWeight: "500",
		fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
		marginTop: "20px",
		marginBottom: "20px",
		padding: "10px",
		fontSize: "16px",
		transition: "0.3s ease all",
		fontWeight: "500",
		lineHeight: "1.428571429",
		color: "#072A40",
		background: " linear-gradient(90deg,#F9F7F0 13%, #F9F7F0 99%)",
		boxShadow:
			"0 12px 20px -10px #e0e0e0, 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px #e0e0e0",
		transition: " all 150ms ease 0s",
		alignItems: "center",
		borderRadius: "3px",
		marginBottom: "20px",
		justifyContent: "flex-start",
	},
	accountSummaryLabel: {
		fontSize: "16px",
		transition: "0.3s ease all",
		lineHeight: "1.428571429",
		fontWeight: "300",
		fontFamily: "Rubik-Medium",
		paddingLeft: "0",
		color: "rgba(" + hexToRgb(blackColor) + ", 0.90)",
	},
	accountSummarySubLabel: {
		fontSize: "14px",
		transition: "0.3s ease all",
		lineHeight: "1.428571429",
		fontFamily: "Rubik-Light",
		fontWeight: "200",
		marginTop: "10px",
		marginBottom: "10px",
		borderLeft: "0.5px solid #A7A7A7FF",
		paddingLeft: "5px",
		color: "rgba(" + hexToRgb(blackColor) + ", 0.90)",
	},
	subscriptionUpdateTitle: {
		display: "flex",
		justifyContent: "space-between",
		fontSize: "16px",
		transition: "0.3s ease all",
		borderBottom: "0.5px solid #A7A7A7FF",
		paddingBottom: "5px",
		lineHeight: "1.428571429",
		fontFamily: "Rubik-Medium",
		fontWeight: "400",
		marginTop: "20px",
		marginBottom: "20px",

		color: "rgba(" + hexToRgb(blackColor) + ", 0.90)",
	},
	subscriptionUpdateLabel: {
		display: "flex",
		justifyContent: "space-between",
		fontSize: "16px",
		transition: "0.3s ease all",
		lineHeight: "1.428571429",
		fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
		fontWeight: "400",
		textAlign: "left",
		marginTop: "10px",
		marginBottom: "10px",
		borderBottom: "0.5px solid #0A9499FF",
		paddingBottom: "5px",
		color: "rgba(" + hexToRgb(blackColor) + ", 0.90)",
	},
	accountSummaryOverLabel: {
		fontSize: "16px",
		transition: "0.3s ease all",
		lineHeight: "1.428571429",
		fontFamily: "Rubik-Medium",
		fontWeight: "300",
		// marginTop: "20px",
		// marginBottom: "20px",
		color: "rgba(" + hexToRgb(blackColor) + ", 0.90)",
	},
	accountSummarySubLabelOverdue: {
		fontSize: "16px",
		transition: "0.3s ease all",
		lineHeight: "1.428571429",
		fontFamily: "Rubik-Light",
		fontWeight: "400",
		marginTop: "10px",
		marginBottom: "10px",
		borderLeft: "0.5px solid #A7A7A7FF",
		paddingLeft: "5px",
		color: "rgba(" + hexToRgb(blackColor) + ", 0.90)",
	},
	redText: {
		color: "#E00000AD",
	},
	label: {
		color: "rgba(" + hexToRgb(blackColor) + ", 0.26)",
		cursor: "pointer",
		display: "inline-flex",
		fontSize: "14px",
		transition: "0.3s ease all",
		lineHeight: "1.428571429",
		fontWeight: "400",
		paddingLeft: "0",
	},
	bigLabel: {
		// color: "rgba(" + hexToRgb(blackColor) + ", 0.80)",
		cursor: "pointer",
		display: "inline-flex",
		fontSize: "18px",
		transition: "0.3s ease all",
		lineHeight: "1.428571429",
		fontWeight: "400",
		paddingLeft: "0",
		fontFamily: "Rubik-Medium",
		color: "#031825FF",
	},
	subLabel: {
		// color: "rgba(" + hexToRgb(blackColor) + ", 0.70)",
		color: "#031825FF",
		cursor: "pointer",
		fontSize: "16px",
		transition: "0.3s ease all",
		lineHeight: "1.428571429",
		fontWeight: "400",
		marginTop: "10px",
		fontFamily: "Rubik-Light",
	},
	textCenter: {
		textAlign: "center",
	},
	leftSide: {
		// borderRight: "1px solid #e0e0e0",
		// BorderTop: "1px solid #e0e0e0",
		minHeight: "100vh",
		maxHeight: "100vh",
		minWidth: "15vw",
	},
	rightSide: {
		minHeight: "100vh",
		maxHeight: "100vh",
		overflowY: "scroll",
		overflowX: "hidden",
		minWidth: "78vw",
	},
	py10: {
		paddingTop: "10px",
		paddingBottom: "20px",
	},

	customerList: {
		position: "relative",
		minHeight: "90vh",
		maxHeight: "90vh",
		overflowY: "scroll",
		overflowX: "hidden",
		marginLeft: "5px",
		marginRight: "5px",
	},
	customerTile: {
		cursor: "pointer",
		fontSize: "14px",
		fontWeight: "500",
		padding: "5px",
		paddingLeft: "10px",
		boxShadow: "1px 0.5px 0.5px #E3E3E3FF",
		transition: "all 0.1s ease",
		"&:hover": {
			backgroundColor: "#F9F7F0",
			transition: "all 0.6s ease",
		},
	},
	selectedTiles: {
		fontWeight: "500",
		backgroundColor: "#F9F7F0",
	},
	customerListDetails: {
		fontSize: "12px",
		fontWeight: "normal",
		color: "#031825FF",
		fontFamily: "Rubik-Regular",
		fontWeight: "200",
	},
	noCustomer: {
		fontSize: "14px",
		fontWeight: "normal",
		color: "#031825FF",
		fontFamily: "Rubik-Regular",
		marginLeft: "10px",
		fontWeight: "200",
	},
	editBtn: {
		color: "#2C2C2CFF",
		borderColor: "#ffffff",
		fontSize: "12px",
		borderRadius: "5px",
		padding: "5px 10px",
		fontWeight: "500",
		textTransform: "none",
		boxShadow: "0.5px 0.5px 1px #072A40",
		transition: "all 0.1s ease",
		fontFamily: "Rubik-Medium",
		fontWeight: "400",
		cursor: "pointer",
		backgroundColor: "#e6f4f1",
		marginRight: "10px",

		"&:hover": {
			backgroundColor: "#F6EFD9FF",
			borderColor: "#F9F7F0",
			color: "#072A40",
			boxShadow: "0.5px 0.5px 1px #072A40",
		},
	},
	customerListWrapper: {
		marginLeft: "5px",
		background: "#FFF",
		paddingTop: "10px",
		paddingBottom: "10px",
		borderRadius: "5px",
		boxShadow:
			"0 12px 20px -10px #e0e0e0, 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px #e0e0e0",
	},
	editBtns: {
		display: "flex",
		justifyContent: "flex-end",
		spaceBetween: "10px",
	},
	cardTitleWhite: {
		...cardTitle,
		color: whiteColor + "  !important",
	},
	searchWrapper: {
		display: "flex",
		justifyContent: "space-between",
		border: "0.5px solid #13354AFF",
		borderRadius: "5px",
		padding: "5px",
		margin: "10px",
	},
	clearIcon: {
		color: "#9e9e9e",
		fontSize: "20px",
		marginLeft: "5px",
		marginRight: "5px",
		cursor: "pointer",
		"&:hover": {
			color: "#072A40",
		},
	},
	confirmOrderBox: {
		padding: "10px",
		border: "1px solid #e0e0e0",
	},
	loading: {
		opacity: "0.4",
	},
	absoluteLoading: {
		// marginTop: "20px",
		position: "absolute",
		top: "5%",
		left: "50%",
		transform: "translate(-50%, -50%)",
	},
	customerTopActionSection: {
		display: "flex",
		justifyContent: "space-between",
		paddingLeft: "10px",
		paddingRight: "10px",
		borderTop: "1px solid #e0e0e0",
		borderBottom: "1px solid #e0e0e0",
	},
	btnPrimary: {
		backgroundColor: "#072A40",
		color: "#ffffff",
		border: "1px solid #072A40",
		fontSize: "12px",
		borderRadius: "5px",
		padding: "5px 10px",
		fontWeight: "bold",
		textTransform: "none",
		fontFamily: "Rubik-Medium",
		fontWeight: "400",
		boxShadow: "0.5px 0.5px 1px rgba(0, 0, 0, 0.2)",
		transition: "all 0.6s ease",
		cursor: "pointer",
		"&:hover": {
			backgroundColor: "#ffffff",
			borderColor: "#072A40",
			color: "#072A40",
			transition: "all 0.6s ease",
		},
	},
	simpleBtn: {
		backgroundColor: "transparent",
		color: "#072A40",
		fontSize: "12px",
		transition: "all 0.1s ease",
		cursor: "pointer",
		"&:hover": {
			color: "#072A40",
		},
	},
	socialLine: {
		marginTop: "1rem",
		textAlign: "center",
		padding: "0",
	},
	socialLineButton: {
		"&, &:hover": { color: whiteColor },
		marginLeft: "5px",
		marginRight: "5px",
	},
	cardLoginHeader: {
		marginTop: "-40px",
		padding: "20px 0",
		width: "100%",
		marginBottom: "15px",
	},
	cardLoginBody: {
		paddingTop: "0",
		paddingBottom: "0",
	},
	justifyContentCenter: {
		WebkitBoxPack: "center !important",
		MsFlexPack: "center !important",
		justifyContent: "center !important",
	},
	infoArea: {
		padding: "0px 0px 20px !important",
	},
	loading: {
		opacity: "0.4",
	},
	space50: {
		height: "50px",
		display: "block",
	},
});

export default customerDetailsStyles;
